import styled from 'styled-components'
import { Box } from '../../atoms'

export const SectionAnalysisContainer = styled(Box)`
  width: 100%;
  background: ${({ theme }) => theme.colors.background.primary};
  padding-bottom: 24px;
`

export const SectionAnalysisTabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  margin-bottom: 16px;
  overflow-x: auto;

  @media (max-width: 768px) {
    margin-bottom: 12px;
  }
`

export const SectionAnalysisTabButton = styled.button<{ $active: boolean }>`
  background: none;
  border: none;
  padding: 12px 20px;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme, $active }) =>
    $active ? theme.colors.primary : theme.colors.text.secondary};
  border-bottom: 2px solid
    ${({ theme, $active }) => ($active ? theme.colors.primary : 'transparent')};
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-width: 96px;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.background.secondary};
  }

  @media (max-width: 768px) {
    padding: 12px 16px;
    font-size: 13px;
    min-width: 100px;
  }
`

export const SectionAnalysisContentContainer = styled.div`
  width: 100%;
  min-width: 0;
  padding-top: 12px;
`

export const SectionAnalysisLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 320px;
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const SectionAnalysisErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 320px;
  color: ${({ theme }) => theme.colors.danger};
  text-align: center;
`

export const SectionAnalysisTabContentContainer = styled.div`
  width: 100%;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 6px;
  }
`
export const AnalysisTabContentContainer = styled.div`
  width: 100%;
  min-width: 0;
  overflow-x: hidden;
  padding: 0 20px 12px 20px;
  container-type: inline-size;

  @media (max-width: 768px) {
    padding: 0 6px;
  }
`

export const SectionAnalysisMetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 16px;

  @container (max-width: 380px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
    margin-bottom: 12px;
  }
`

export const SectionAnalysisChartGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;

  @container (max-width: 700px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  @media (max-width: 768px) {
    gap: 12px;
    margin-bottom: 12px;
  }
`

export const SectionAnalysisChartContainer = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 8px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};

  @media (max-width: 768px) {
    padding: 12px;
  }
`

export const SectionAnalysisChartTitle = styled.h3`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 8px 0;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 8px;
  }
`

export const SectionAnalysisChartSubtitle = styled.p`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0 0 12px 0;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 11px;
    margin-bottom: 10px;
  }
`

export const SectionAnalysisInsightCard = styled.div`
  background: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: 6px;
  padding: 12px;
  border-left: 4px solid ${({ theme }) => theme.colors.primary};
  margin-top: 12px;

  @media (max-width: 768px) {
    padding: 10px;
    margin-top: 10px;
  }
`

export const SectionAnalysisInsightTitle = styled.h4`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 6px 0;
`

export const SectionAnalysisInsightText = styled.p`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
  line-height: 1.4;
`

export const SectionAnalysisFilterContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 20px;
  padding: 12px;
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    padding: 10px;
  }
`

export const SectionAnalysisFilterLabel = styled.label`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
  white-space: nowrap;
`

export const SectionAnalysisFilterSelect = styled.select`
  padding: 6px 10px;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-radius: 5px;
  background: ${({ theme }) => theme.colors.background.primary};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 12px;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
  }
`

export const SectionAnalysisFilterSection = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  flex-shrink: 0;
  padding: 0px 0px 20px 0px;
`

export const SectionAnalysisFilterBar = styled.div`
  padding: 16px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  min-height: 54px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`

export const SectionAnalysisLocationFilters = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  flex-wrap: wrap;
  padding: 0 ${({ theme }) => theme.spacing.large};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    align-items: stretch;
    padding: 0 ${({ theme }) => theme.spacing.small};
  }
`

export const SectionAnalysisFilterChip = styled.div<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 11px;
  background: ${({ theme, $active }) =>
    $active ? theme.colors.primary + '20' : theme.colors.background.secondary};
  color: ${({ theme, $active }) =>
    $active ? theme.colors.primary : theme.colors.text.primary};
  border: 1px solid
    ${({ theme, $active }) =>
      $active ? theme.colors.primary : theme.colors.border.light};
  border-radius: 16px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  user-select: none;

  &:hover {
    background: ${({ theme, $active }) =>
      $active ? theme.colors.primary + '30' : theme.colors.background.tertiary};
    border-color: ${({ theme, $active }) =>
      $active ? theme.colors.primary : theme.colors.border.default};
    transform: translateY(-1px);
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    width: 11px;
    height: 11px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 8px 16px;
    font-size: 14px;
    flex: 1;
    justify-content: center;
  }
`

export const SectionAnalysisLocationBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  color: ${({ theme }) => theme.colors.text.primary};
  border-radius: 13px;
  font-size: 10px;
  font-weight: 500;

  svg {
    width: 10px;
    height: 10px;
  }
`

export const SectionAnalysisDivider = styled.div`
  width: 1px;
  height: 12px;
  background: ${({ theme }) => theme.colors.border.light};
`

export const SectionAnalysisAdvancedFiltersToggle = styled.button<{
  $expanded?: boolean
}>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 11px;
  background: ${({ theme, $expanded }) =>
    $expanded ? theme.colors.primary : theme.colors.background.primary};
  color: ${({ theme, $expanded }) =>
    $expanded ? theme.colors.text.inverse : theme.colors.text.secondary};
  border: 1px solid
    ${({ theme, $expanded }) =>
      $expanded ? theme.colors.primary : theme.colors.border.default};
  border-radius: 16px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  margin-left: auto;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme, $expanded }) =>
      $expanded ? theme.colors.text.inverse : theme.colors.primary};
  }

  svg {
    width: 11px;
    height: 11px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 8px 16px;
    font-size: 14px;
  }
`

export const SectionAnalysisAdvancedFiltersPanel = styled.div<{
  $expanded?: boolean
}>`
  display: ${({ $expanded }) => ($expanded ? 'block' : 'none')};
  margin-top: 0;
  padding: 16px 20px;
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: 10px;
  animation: slideDown 0.2s ease-out;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const SectionAnalysisAdvancedFiltersHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};

  .header-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.text.primary};
  }

  svg {
    width: 13px;
    height: 13px;
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`

export const SectionAnalysisAdvancedFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    align-items: stretch;
  }
`
